import React from "react";
import Grid from "@mui/material/Grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import ListBarang from "../../../components/ListBarang/ListBarang";
import ListPesan from "../../../components/ListPesan/ListPesan";

type TransaksiLayoutProps = {
    isCardView: boolean;
    onCardView: () => void;
    onListView: () => void;
    onError: () => void;
    onOpenMutasi: () => void;
};

const TransaksiLayout = ({
    isCardView,
    onCardView,
    onListView,
    onError,
    onOpenMutasi,
}: TransaksiLayoutProps) => {
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("md", "lg"));

    return (
        <Grid container>
            <Grid
                item
                xs={12}
                sm={12}
                md={isTabletScreen ? 5.5 : isCardView ? 7 : 6}
                sx={{
                    overflowY: "scroll",
                }}
            >
                <ListBarang
                    isCardView={isCardView}
                    cardView={onCardView}
                    listView={onListView}
                    handleIsError={onError}
                    onOpenMutasi={onOpenMutasi}
                />
            </Grid>
            <Grid
                id="barangPesanan"
                item
                xs={12}
                sm={12}
                md={isTabletScreen ? 6.5 : isCardView ? 5 : 6}
                sx={{
                    borderLeft: isPhoneScreen
                        ? undefined
                        : "1px solid rgba(0, 0, 0, 0.12)",
                    borderRight: isPhoneScreen
                        ? undefined
                        : "1px solid rgba(0, 0, 0, 0.12)",
                }}
            >
                <ListPesan handleIsError={onError} />
            </Grid>
        </Grid>
    );
};

export default TransaksiLayout;
